import React, { Component } from 'react';
import ReactQuill from 'react-quill-new';
import { PropTypes } from 'prop-types';

import './Editor.css';
import "react-quill-new/dist/quill.core.css";
import "react-quill-new/dist/quill.bubble.css";
import "react-quill-new/dist/quill.snow.css";


/**********************************************
* Wrapper for react-quill
* 
* findDOMNode is deprecated and will be removed in the next major release.
* https://github.com/zenoamaro/react-quill/issues/981
*/
export default class Editor extends Component {

  static propTypes = {
    placeholder: PropTypes.string,
  }
  static modules = {
    toolbar: false,
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  };
  static formats = false;


  quillRef = React.createRef(null);

  /*
   * Quill modules to attach to editor
   * See https://quilljs.com/docs/modules/ for complete options
   */
  static getModules(readonly) {
    if (!readonly) {
      Editor.modules.toolbar = [
        [{ 'header': '1'}, {'header': '2'}, { 'font': [] }], [{size: []}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'},
         {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image', 'video'],
        ['clean']
      ];
    }
    return Editor.modules;
  }

  /*
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  static getFormats(readonly) {
    if (!readonly) {
      Editor.formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
      ];
    }
    return Editor.formats;
  }

  constructor (props) {
    super(props);
    this.state = {
      editorHtml: '',
      theme: 'snow',
    };
    this.setValue = this.setValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ editorHtml: this.props.value || '' });
  }

  setHTML(value) {
    this.setState({ editorHtml: value || '' });
  }

  handleChange(html) {
  	this.setState({ editorHtml: html });
    if (this.props.onChange) {
      this.props.onChange(html);
    }
  }

  setValue(value) {
    const quill = this.quillRef.current.getEditor();

    this.setState({ editorHtml: value || ''}, () => {
      quill.focus();
      quill.clipboard.dangerouslyPasteHTML(value);

      //quill.setSelection(newValueObject.indexAfterInsertion, 0, quill);
    });
  }
  
  handleThemeChange(newTheme) {
    if (newTheme === "core") newTheme = null;
    this.setState({ theme: newTheme })
  }
  
  render () {
    return (
        <ReactQuill 
          ref={this.quillRef}
          theme={this.state.theme}
          onChange={this.handleChange}
          value={this.state.editorHtml}
          modules={Editor.getModules(this.props.disabled)}
          formats={Editor.getFormats(this.props.disabled)}
          bounds={'.app'}
          placeholder={this.props.placeholder}
          readOnly={this.props.disabled}
         />
     );
  }
}

